var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111 127",
    width: 111,
    height: 127,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 111,
    height: 127,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAAB/CAMAAADWzWzJAAAAAXNSR0IB2cksfwAAAGBQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////BmKR8wAAACB0Uk5TAID/QN8gn78KcM8qMMnpEO9QHp403XxgFGYpPa9cjzMJft7CAAAB60lEQVR4nO3bbU/CMBAH8HYPbCFkGsQQfKHf/3P5RlREDUiAjTnAhdvdhpLQQ/R/r2jY9bcNaEs5rGkKa3eP87zxsDJ8cohnl429/oQzJlgcwO0DmzyfXdF3V+hVm+EcHjx48OC58eLqiN5iCUG232OnE1fT4ynzOotoatxFZ55mxLuYtd8dapsI2+PS69qxa60I7/J563X9kQJXRO9x47VSHW6zyrBsoeI0ik+J5Z8cp2Ez239S9IKFVXv11hEnVvN2GtOHBw8ePHhn4unN7usY6HJ79l/gwfsNXqTK9f78eAYPHjx48M7T866Gu4YfiN+5gozshNasXunGrEyX3vWQtkK+zRqHb7Qpdm+qP9yJdOGx/kSH1dMRHcZLtk3M0oXHN575HbMMODAdHjx4/9jTHs+0x2uTfJBjVv6KPW3iGcmQ05UJyRnI9NPPt/DgwYMHD16t55H5r1VTdhiSGbVu95R8H5Pp0rt5nZC+U95jEr2QTnzLJ1QvJ6cr04WXpJNKO2AdssJMXi2QRNX1DU8/+foMHjx48Fx52uOn9vygPv+5DXjwDvO06xW16zHFkOMwisFSv55Wu17YhLnSHf2qh9aq9x7cm3KE74+cX2K+3Uss3yy3w8a/mB0hPL+c93dvzjuH3vyhfPQJAMAHD800ETkAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCalendar);
export default __webpack_public_path__ + "static/media/event-calendar.08bc036e1d63757703b88678dc51d773.svg";
export { ForwardRef as ReactComponent };